import React from 'react'
import './styles/AppHeader.css'

const AppHeader = () => {
  return (
    <div className="appHeader">
      {"METAR4u"}
    </div>
  )
}

export default AppHeader



// WEBPACK FOOTER //
// ./src/components/AppHeader.js